import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { ROUTE_BOOK_LOCATION, ROUTE_ROOT } from '../util/constants';

interface RequireLocationProps {
  children: JSX.Element;
}

export default function RequireLocation({ children }: RequireLocationProps) {
  const serviceLocation = useAppSelector((state) => (
    state.serviceLocation));

  const location = useLocation();

  if (!serviceLocation.serviceAddress) {
    return <Navigate to={ROUTE_ROOT} state={{ from: location }} />;
  }

  // An address the service-area check said we do not serve goes no further
  // than the address step, however the later step's URL was reached.
  if (serviceLocation.inService === false) {
    return <Navigate to={ROUTE_BOOK_LOCATION} state={{ from: location }} />;
  }

  return children;
}
